(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { useEffect } from "react";
import { useDispatch, useSelector } from "../../../../store";
import { init as initAction } from "../../state/actions";
import { isSearchReadySelector } from "../../state/selectors";

const useInit = () => {
  const dispatch = useDispatch();
  const isReady = useSelector(isSearchReadySelector);
  useEffect(() => {
    if (!isReady) {
      dispatch(initAction());
    }
  });
  return {
    isReady
  };
};

__signature__(useInit, "useDispatch{dispatch}\nuseSelector{isReady}\nuseEffect{}", () => [useDispatch, useSelector]);

const _default = useInit;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useInit, "useInit", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/containers/hooks/useInit.js");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/containers/hooks/useInit.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();